<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_ii"></a><a id="page_iii"></a><a id="title"></a><strong>HOW TO<br/>GET IDEAS</strong></h1>
<p class="center"><strong>Second Edition</strong></p>
<p class="author"><img alt="Image" src="images/f00iv-01.jpg"/></p>
<p class="author">Jack Foster<br/><strong>illustrations by Larry Corby</strong></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?7b740e90